import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SearchForm from '~components/ui/SearchForm'
import classNames from 'classnames'
import RoundedIcon from '~components/ui/RoundedIcon'

class SearchOverlay extends Component {
  render () {
    return (
      <div className={classNames('flex transition-transform transform duration-150 ease-in-out items-center absolute top-0 z-50 w-full h-full px-4 py-3 bg-white border-coral border-b md:-translate-y-full', { '-translate-y-full': !this.props.showOverlay })}>
        <SearchForm />

        <button type="button" className="group w-10 h-10 block ml-4" onClick={this.props.toggleOverlay.bind(this)}>
          <RoundedIcon name="crossAlt" className="w-10 h-10 block" />
        </button>
      </div>
    )
  }
}

SearchOverlay.propTypes = {
  className: PropTypes.string,
  toggleOverlay: PropTypes.func.isRequired,
  showOverlay: PropTypes.bool.isRequired
}

export default SearchOverlay
